
import { Arr } from '@deqo/foundation';
import { Sounds } from '../../../@resources/sounds';
import { telemetry } from '../../../@vendor/Posthog';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { booleanStep, stringStep } from '../../../concepts/commands/CommandWizard';
import { Communicator } from '../../../concepts/objects';
import { AudioManager } from '../../../platform/AudioManager';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { Camera } from '../../canvas/Camera';
import { EditorSession } from '../../canvas/EditorSession';
import { MyRoleInfo } from '../../canvas/MyRoleInfo';
import { resolveSubject } from '../../canvas/commands/CommandUtil';
import { RelativeTo } from '../../canvas/entities/Physical';

export const herd = defineCommand(
    'herd',
    null,
    async (cc, [fx, fy, tx, ty, sound]: [number, number, number?, number?, string?]) => {
        const region = (typeof (tx) === 'number' && typeof (ty) === 'number')
            ? Rect.fromPoints([new Point(fx, fy), new Point(tx, ty)])
            : new Rect(fx, fy, 1, 1);

        const camera = cc.resolve(Camera);
        const { canManage } = cc.resolve(EditorSession).get(MyRoleInfo);

        if (canManage) {
            cc.resolve(Communicator).send('herd', [...region.toArray(), sound]);
            telemetry.emit('facilitator.herd');

            if (sound) {
                const audio = cc.resolve(AudioManager);
                audio.play('Herd', Sounds[sound], 0.5);
            }

            await camera.animateToFrame(region);
        }
    }
);

export const herdToMe = defineCommand(
    'herdToMe',
    'Herd: To Me',
    (cc, [egg]: [boolean?]) => {
        const camera = cc.resolve(Camera);
        const dispatch = cc.resolve(CommandDispatcher);

        const view = camera.getModelFrame();
        const tl = view.topLeft();
        const br = view.bottomRight();
        const sound = egg ? Arr.random(['Scorpion1', 'Scorpion2']) : null;

        dispatch(herd, [tl.x, tl.y, br.x, br.y, sound]);
    },
    [
        booleanStep('egg', 'Egg? [y/N]', false)
    ]
);

export const herdToElement = defineCommand(
    'herdToElement',
    'Herd: To Element...',
    (cc, [id]: [string]) => {

        const subject = resolveSubject(cc, id);
        if (!subject) return;

        const dispatch = cc.resolve(CommandDispatcher);
        const bounds = subject.bounds(RelativeTo.Model);
        const tl = bounds.topLeft();
        const br = bounds.bottomRight();

        dispatch(herd, [tl.x, tl.y, br.x, br.y]);
    },
    [
        stringStep('id', 'Element ID'),
        booleanStep('egg', 'Egg? [y/N]', false)
    ]
);

export const inHerdingCommands = () => inCommands(
    herd,
    herdToMe,
    herdToElement,
);

